import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../../../components/Icon/Icon.js';
import styles from './RssiItem.module.scss.js';

var RssiItem = function RssiItem(_ref) {
  var _ref$iconInfo = _ref.iconInfo,
    icon = _ref$iconInfo.icon,
    color = _ref$iconInfo.color,
    title = _ref.title,
    description = _ref.description,
    dataTestId = _ref.dataTestId;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: styles.rssiItem
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.icon
  }, /*#__PURE__*/React.createElement(Icon, {
    dataTestId: dataTestId,
    icon: icon,
    size: "xlarge",
    color: color
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.rssiTitle
  }, title), description && /*#__PURE__*/React.createElement("div", {
    className: styles.text
  }, description)));
};
RssiItem.propTypes = {
  iconInfo: PropTypes.shape({
    icon: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired
  }).isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  dataTestId: PropTypes.string.isRequired
};
RssiItem.defaultProps = {
  description: undefined
};

export { RssiItem };
